import { z } from "zod";
import { PostStatus } from "../enum.js";

export const postStatusSchema = z.enum(PostStatus);

export const composerPollSchema = z.object({
	question: z.string(),
	options: z.array(z.string().min(1).max(200)).min(2).max(10),
});

export const composerFormSchema = z
	.object({
		content: z.string(),
		group_ids: z.array(z.uuid()),
		poll: composerPollSchema.nullable(),
		status: postStatusSchema,
		scheduled_at: z.iso.datetime().nullable(),
	})
	.refine((data) => data.status !== PostStatus.SCHEDULED || Boolean(data.scheduled_at), {
		path: ["scheduled_at"],
		message: "scheduled_at_required",
	});

export type ComposerFormValues = z.infer<typeof composerFormSchema>;
export type ComposerPollPayload = z.infer<typeof composerPollSchema>;
